import { connect } from 'react-redux';
import ButtonAct from './ButtonAct';
import { popupActShow, dopPopupShow, getPopupActReport } from '../../../store/actions/popupAct';
import { setVisiblePopupSignSelected } from '../../../store/actions/documents';
import { modalErrorOpen } from '../../../store/actions/modalError';

const mapStateToProps = ({
  popupActReducer
}) => ({
  popupActReducer
});
const mapDispatchToProps = {
  dopPopupShow,
  getPopupActReport,
  popupActShow,
  setVisiblePopupSignSelected,
  modalErrorOpen
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ButtonAct);
